<template>
  <div class="home">
<TelefonoNavar/>
<TelefonoBanner/>
<CategoriasView/>
<ServiciosFAQ/>
<FooterSection/>
  </div>
</template>

<script>
import TelefonoNavar from '@/components/TelefonoView/TelefonoNavar.vue';
import TelefonoBanner from '@/components/TelefonoView/TelefonoBanner.vue';
import CategoriasView from '@/components/CategoriasView.vue';
import ServiciosFAQ from '@/components/TelefonoView/ServiciosFAQ.vue';
import FooterSection from '@/components/FooterSection.vue';

export default {                                                                                                            
  name: 'TelefonoView',
  components: {
TelefonoNavar,
TelefonoBanner,
CategoriasView,
ServiciosFAQ,
FooterSection,
  }
}
</script>